import { StreamType } from '@/__generated__/graphql.ts';
import { makeSelectOptions } from '@/routes/_app.p.marketplace.streams/stream-filters/make-select-options.ts';
import { StreamFilterItem } from '@/routes/_app.p.marketplace.streams/stream-filters/stream-filters.tsx';

const StreamsTypeOptions = {
  All: 'All types',
  [StreamType.Public]: 'Public',
  [StreamType.Private]: 'Private',
};

const streamsTypeSelectOptions = makeSelectOptions(StreamsTypeOptions);

export const StreamTypeFilter = () => {
  return (
    <StreamFilterItem
      paramName={'streamType'}
      defaultValue={'All'}
      optionsEntity={StreamsTypeOptions}
      options={streamsTypeSelectOptions}
    />
  );
};
